/* eslint-disable no-secrets/no-secrets */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import MLAgentChoiceReportService from '../../../../capabilities/gw-capability-gateway/services/MLAgentChoiceReportService'
import UserService from '../../../../capabilities/gw-capability-gateway/services/UserService'
import GatewayMLGAFInfoService from '../../../../capabilities/gw-capability-gateway/services/MLGAFInfoService';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLProductCodeUtil, MLUserTypeUtil, MLLocalDateUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil, MLWizardNavUtil, MLGafUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { LoadSaveService, MLPortalSettingsService, MLGAFInfoService } from 'gw-capability-quoteandbind';
import { LoadSaveService as GatewayLoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { MLMultiLobsDataHolderService, MLHistoryService } from 'ml-services-common-react';
import { MLEmployersAffiliationsComponent } from 'ml-components-common-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { MLUWIssuesPanelComponent } from "gw-capability-gateway-quoteandbind-common-react";
import metadata from './AffiliationPage.metadata.json5';
import messages from './AffiliationPage.messages';
import styles from './AffiliationPage.module.scss';
import MLAdditionalCarrierPopup from '../../popups/MLAdditionalCarrier/MLAdditionalCarrierPopup';

const QUESTIONS_TO_SHOW = [
    'HOPOccupationType_Ext',
    'HOPEducationLevel_ML'
];

const PERSONAL_AUTO = 'PersonalAuto';
const PERSONAL_UMBRELLA = 'PersonalUmbrella';
const stepNames = {
    [PERSONAL_AUTO]: ['paPreFillData'],
    [PERSONAL_UMBRELLA]: ['pupUnderlyingPolicies']
};

const AffiliationPage = (props) => {
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        isSkipping,
        steps,
        changeNextSteps,
        updateWizardSnapshot,
        currentStep,
        history
    } = props;
    const [enforceSearch, setEnforceSearch] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const gafPathAspects = 'baseData.gafInfo_ML.aspects';
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isGPA = appConfig.portalCode === 'GPA';
    const isQNB = appConfig.portalCode === 'QB';
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const getNewBusinessEffectiveDate = _.get(submissionVM, 'baseData.gafInfo_ML.newBusinessEffectiveDate.value', undefined)
    const getPeriodStartDate = _.get(submissionVM, 'baseData.periodStartDate.value', undefined)
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const { saveBindableChoiceReport } = MLAgentChoiceReportService();
    const [isOpenAdditionalCarrierPopup, setIsOpenAdditionalCarrierPopup] = useState(null)
    const [showAdditionCarrierBtn, setshowAdditionalCarrierBtn] = useState(false)
    const [additionalCarrierData, setAdditionalCarrierData] = useState(null)
    const userType = _.get(submissionVM, 'userType_ML.value.code', '')
    const crCompGroupSteps = ["compPaGroupAssociations", 'compHoGroupAssociations'];
    const GCS_SALES_USER = 'gcssales_ml';
    const GCS_SERVICE_USER = 'gcsservice_ml';
    const gafPath = 'baseData.gafInfo_ML';
    const [getFailedToUpdateGafInfo, setFailedToUpdateGafInfo] = useState(false);
    const quoteId = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
    const sessionId = _.get(submissionVM, 'sessionUUID.value', undefined);
    const viewModelService = useContext(ViewModelServiceContext);
    const gafPathValue = 'baseData.gafInfo_ML.value';
    const [shouldBlockOnNext, setShouldBlockOnNext] = useState(false);
    const [organization, setOrganization] = useState(undefined);

    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false) || _.get(submissionVM, 'baseData.isModernProduct_Ext.value', false)
    
    const isGpcValidationDisabled =  _.get(submissionVM, 'disableGPCCheckForGcsSales_Ext.value', false);
    
    const { MLCustomHistoryTypes, MLPaymentChannels, MLGafDefaults, mercerOrganization, mercerGpcCode } = appConfig;
    const { isNonServicingState, isQnBEmployerNameDataValid } = MLGafUtil();
    const showSkipEmployerDiscount = isQNB && isNonServicingState(submissionVM) && _.isEmpty(_.get(submissionVM, "baseData.gafInfo_ML.gpcCode.value"));    

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const { nextStepVisited, canShowReturnToQuoteButton, isLastStep } = MLWizardNavUtil(props);

    const {
        addErrorAlert,
        clearErrorAlerts,
        clearBlockAlerts,
        addWarningAlert,
    } = MLNotificationBlockUtil();

    const setCanRequoteFlag = useCallback(async () => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    const checkForGroupAffiliationUwIssues = useCallback(() => {
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value;
        if (uwIssues?.length > 0) {
            const groupUwIssues = uwIssues.filter((issue) => {
                return issue.checkingSet_Ext === 'PreQuote' && issue.currentBlockingPoint === 'BlocksQuote' && issue.code_ML === 'BR10898';
            });
            if (groupUwIssues?.length > 0) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(groupUwIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const prequoteCheckpointIssues = issues.filter((issue) => {
                return issue.checkingSet_Ext === 'PreQuote' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(prequoteCheckpointIssues?.length > 0);
        }
    }, []);
    const updateAdditionalCarrier = (quotes, applications) => {
        setAdditionalCarrierData({ quotes, applications })
    }

    const saveBindableReport = async () => {

        const params = {
            quotes: additionalCarrierData.quotes,
            applications: additionalCarrierData.applications,
            agentId: _.get(submissionVM, 'producerCodeOfRecord_ML.group_ML.agentID.value', ''),
            accountNo: _.get(submissionVM, 'baseData.accountNumber.value', ''),
            gPCCode: _.get(submissionVM, "baseData.gafInfo_ML.gpcCode.value", MLGafDefaults.GPC_CODE),
            state: _.get(submissionVM, 'baseData.accountHolder.primaryAddress.state.value.code', ''),
            pCISCode: _.get(submissionVM, "baseData.gafInfo_ML.pcisCode.value", MLGafDefaults.PCIS_CODE),
            salesPortal: MLPaymentChannels.AGENT?.toUpperCase(),
            producerTypeCode: _.get(submissionVM, "producerCodeOfRecord_ML.producerType_ML.value.code"),
            customerTypeInd: _.get(submissionVM, 'baseData.gafInfo_ML.customerTypeIndicator.value')
        };

        await saveBindableChoiceReport(params, authHeader).finally(() => setAdditionalCarrierData(null))
    }



    useEffect(() => {
        if (!isSkipping) {
            if (isGPA) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    if (user?.primaryProducerCode_ML?.organization_ML) {
                        setOrganization(user?.primaryProducerCode_ML?.organization_ML.name?.toLowerCase().includes(mercerOrganization));
                    }               
                    
                    if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Affiliation Page' });
                    }
                    else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Affiliation Page' });
                    }
                    else {
                        PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Affiliation Page' });
                    }
                });
            } else {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'AffiliationPage' }, true);
                } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Affiliation Page' }, true);
                } else {
                    PATrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Affiliation Page' }, true);
                }
            }            
        }


        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            setshowAdditionalCarrierBtn(!!response?.enableBindableIQA_Ext);
        });

        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []);

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    useEffect(() => {
        if(isQNB && submissionVM?.hvqQuoteID_ML?.value && sessionStorage.getItem('isBindableGPCSelected') !== "true") {
            const employerName = _.get(submissionVM, 'baseData.gafInfo_ML.accountName.value');
            const gpcCodeBindable = _.get(submissionVM, 'baseData.gafInfo_ML.gpcCode.value');


            if(employerName) {
                sessionStorage.setItem('employerName', employerName);
                sessionStorage.setItem('gpcCode', gpcCodeBindable);
                const newVm = viewModelService.clone(submissionVM);
                _.set(newVm, gafPathValue, {});
                updateWizardData(newVm);
            }
        }


    },[]) 

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
            return false;
        }

        if (!MLProductCodeUtil.isPersonalUmbrella(productCode) && MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (MLProductCodeUtil.isPersonalUmbrella(productCode)
            && submissionVM.value.isBundle_ML
            && submissionVM.value.baseData.status_ML !== 'Quoted') {
            return false;
        }

        if (submissionVM.isBundle_ML.value
            && submissionVM.baseData.status_ML.value !== 'Draft') {
            return true;
        }

        if (MLProductCodeUtil.isHomeOwners(productCode)) {
            if(crCompGroupSteps?.includes(currentStep?.mlStepName) && 
            (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid)) {
                return false;
            }

            const questionsToShow = ['zc8huuoqepdeh69me02j30ri208', 'zs5hitumv115g03os3gv499tk3b'];
            const questionSet = submissionVM.lobData.homeowners.dwellingAdditionalInfo.value[0];
            let skip = true;
            questionsToShow.forEach((questionCode) => {
                if (questionSet.answers[questionCode] === null) {
                    skip = false;
                }
            });
            return skip;
        }

        return true;
    };

    const {
        onValidate,
        isComponentValid,
        registerComponentValidation
    } = useValidation('AffiliationPage');

    const onUpdateSearchVal = useCallback((val) => {
        setEnforceSearch(val);
    }, []);

    const areQuestionsInvalid = useCallback(() => {
        if (MLProductCodeUtil.isHomeOwners(productCode) || MLProductCodeUtil.isHomeOwnersPartialTypeRental(productCode)) {
            const answers = _.get(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0].answers', {});
            if (!isModernProduct && QUESTIONS_TO_SHOW.some((qName) => _.isUndefined(answers[qName]) || _.isEmpty(answers[qName]) || _.isNull(answers[qName]))) {
                return false;
            } else {
                return true;
            }
        }
    }, [productCode, submissionVM]);

    const validateAffiliationFields = useCallback(() => {
        const gafVmAspects = _.get(submissionVM, gafPathAspects, {});
        if ((!_.isEmpty(gafVmAspects) && (!gafVmAspects.valid || !gafVmAspects.subtreeValid)) || areQuestionsInvalid()) {
            return false;
        }
        return true;
    }, [areQuestionsInvalid, submissionVM]);

    useEffect(() => {
        registerComponentValidation(validateAffiliationFields);
    }, [registerComponentValidation, validateAffiliationFields]);

    const validateData = useCallback((isReturnToQuote = false) => {
        const isCRGroup = crCompGroupSteps.includes(currentStep?.mlStepName) ? true : false;

        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            if (isCRGroup) {
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'compPaGroupAssociations');
            } else {
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'paGroupAssociations');
            }
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            if (isCRGroup) {
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'compHoGroupAssociations');
            } else {
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'hoGroupAssociations');
            }
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupGroupAssociations');
        }

        clearErrorAlerts();

        if (submissionVM.baseData.productCode.value === 'HOPHomeowners' && !isCRGroup && !(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && areQuestionsInvalid())) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        } else if (!isCRGroup && !(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }

        const now = moment();
        const formatPeriodStart = moment(MLLocalDateUtil?.localDate2Date(getPeriodStartDate))
        const formatNewEffectiveDate = moment(MLLocalDateUtil?.localDate2Date(getNewBusinessEffectiveDate))

        if (!isCRGroup && formatNewEffectiveDate.isValid() && formatNewEffectiveDate.isAfter(now) && formatPeriodStart.isBefore(formatNewEffectiveDate)) {
            const newBusinessEffectiveDate = formatNewEffectiveDate.format('MM/DD/YY')

            addErrorAlert(translator(messages.futureEffectiveDateError, { newBusinessEffectiveDate }))

            if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid) {
                updateWizardSnapshot(submissionVM)
            }

            return false;
        }

        clearBlockAlerts('multipleOptionsEmployer/Affiliation');
        if (!isQNB && enforceSearch) {
            addWarningAlert(messages.searchAlert, 'multipleOptionsEmployer/Affiliation');
            return false;
        }

        if(isQNB && !_.isEmpty(sessionStorage.getItem('employerName')) && isQnBEmployerNameDataValid(sessionStorage.getItem('employerName')) && _.isEmpty(_.get(submissionVM, "baseData.gafInfo_ML.gpcCode.value"))) {
            //addWarningAlert(messages.qnbGPCMissing, 'qnbGPCMissing');
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            setShouldBlockOnNext(true);
            return false; 
        } else {
            setShouldBlockOnNext(false);
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }
        return true;
    }, [addWarningAlert, areQuestionsInvalid, authHeader, clearBlockAlerts, currentStep.mlStepName, enforceSearch, errorTimestamp, productCode, submissionVM]);

    const checkGPCCode = (submissionVM) => {
        if ((isModernProduct && !isGpcValidationDisabled) && (userType === GCS_SALES_USER || isQNB)) {
            const hasGPCCode = _.get(submissionVM, 'baseData.gafInfo_ML.gpcCode.value')
            if (!hasGPCCode) {
                clearErrorAlerts()
                return (addErrorAlert(translator(messages.gcsDirectChannelErrorMsg)));
            }
        }
        return true;
    }

    const updateGAFInfo = useCallback( async (executeOnlyIfPreviousUpdateFailed) => {
        const gafVm = _.get(submissionVM, gafPath, {});

            if (gafVm?.aspects?.valid && gafVm?.aspects?.subtreeValid) {
                if (executeOnlyIfPreviousUpdateFailed || getFailedToUpdateGafInfo) {

                if(gafVm?.employeeNumber?.value === "") {
                    gafVm.employeeNumber.value = null;
                }

                if(gafVm?.departmentNumber?.value === "") {
                    gafVm.departmentNumber.value = null;
                }

                if(gafVm?.employeeDepartmentNumber?.value === "") {
                    gafVm.employeeDepartmentNumber.value = null;
                }

                showProgressDialog(platformMessages.loading);

                    let res;                     
                    if (isGPA) {
                        res = await GatewayMLGAFInfoService.gpaUpdateGAFInfo(gafVm.value, quoteId, authHeader);
                    } else {
                        res = await MLGAFInfoService.updateGAFInfo(gafVm.value, sessionId, quoteId);
                    }
                    
                    hideProgressDialog();                    
                        
                    setFailedToUpdateGafInfo(false);

                const newVm = viewModelService.clone(submissionVM);

                _.set(newVm, gafPathValue, res);
                updateWizardData(newVm);                    
            }
        } else {
            setFailedToUpdateGafInfo(true);
        }
    }, [submissionVM, getFailedToUpdateGafInfo, isGPA, showProgressDialog,
        quoteId, authHeader, sessionId, viewModelService, updateWizardData]);
    
    const onNext = useCallback(async() => {
            const gafVm1 = _.get(submissionVM, gafPathValue, undefined);

            if(isGPA && organization && !(gafVm1?.gpcCode && gafVm1?.gpcCode === mercerGpcCode)) {
                clearErrorAlerts();
                addErrorAlert(translator(messages.employerGpcErrorMsg))

                return false;
        }

            if (!isQNB && !_.isEmpty(gafVm1?.gpcCode) && !_.isNull(gafVm1?.gpcCode)) {  
                
                await updateGAFInfo(true)                                    
            }

        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' });
                }
                else {
                    PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' });
                }
            })
        } else {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' }, true);
                } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' }, true);
                } else {
                    PATrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Affiliation Page', action: 'Affiliation Page Submitted' }, true);
                }
        }

        var isCompRater = crCompGroupSteps?.includes(currentStep?.mlStepName)

        if (isCompRater) {
            // handle missing bypassCreditOrdering_Ext
            if (_.isUndefined(_.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value'))) {
                const user = await UserService.getCurrentUser(authHeader);
                if (user?.primaryProducerCode_ML?.code?.startsWith('9SM')) {
                    _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', true);
                } else {
                    _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false);
                }
            }

            // handle missing email address
            _.set(submissionVM, 'bypassValidationForComprater_Ext', true);

            // handle multiple policy  policy number
            const paModifiers = _.get(submissionVM, 'lobData.personalAuto.modifiers_ML.lineModifiers.value');
            if (paModifiers) {
                const multiplePolicyNumberModifier = paModifiers.find((modifier) => modifier.codeIdentifier_ML === 'PAMultiplePolicyHomePolicyNumber_ML');
                if (multiplePolicyNumberModifier) {
                    console.log('updating the multiple policy number')
                    multiplePolicyNumberModifier.chosenTermValue = '123456789'
                }
            }
        }

        const isGPCCodeValid = checkGPCCode(submissionVM);
        if(!isGPCCodeValid){
            return false;
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        if(isQNB && (!_.isEmpty(sessionStorage.getItem('gpcCode')) || !_.isEmpty(sessionStorage.getItem('employerName')))){
            sessionStorage.removeItem('gpcCode');
            sessionStorage.removeItem('employerName');
        }    

        if (additionalCarrierData?.quotes?.length > 0 || additionalCarrierData?.applications?.length > 0) {
            await saveBindableReport()
        }

        if (!submissionVM.value.isQuoted()) {
            _.unset(submissionVM.value, 'bindData');
        }

        let nextStepName;

        if (submissionVM.isSubmitAgent.value && submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value) {
            if (MLProductCodeUtil.isPersonalAuto(productCode)) {
                nextStepName = isCompRater ? 'compPaPrefillResults' : 'paHVQPreFillDiscrepanciesCheck';
            } else {
                nextStepName = isCompRater ? 'compHoValidateInfo' : 'hoHVQPreFillDiscrepanciesCheck';
            }

            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            const coverageType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', undefined);
            if (coverageType === 'hoprental') {
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/construction'
                );
                if (index > 0) {
                    const remainingSteps = _.slice(steps, index + 1);
                    changeNextSteps(remainingSteps);
                }
                nextStepName = 'hoRating';
            } else {
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/construction'
                );
                if (index > 0) {
                    const remainingSteps = _.slice(steps, index);
                    changeNextSteps(remainingSteps);
                }
                nextStepName = 'hoConstruction';
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, isGPA && authHeader);
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            nextStepName = 'pupUnderlyingPolicies';
        } else {
            // Skip paHVQPreFillDiscrepanciesCheck and go to prefill page for non-hvq submission
            const index = _.findIndex(
                steps,
                ({ path }) => path === '/hvq-prefill-discrepancies-check'
            );
            if (index > 0) {
                const remainingSteps = _.slice(steps, index + 1);
                changeNextSteps(remainingSteps);
            }
            const [nextStepName] = stepNames[productCode];
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, isGPA && authHeader);
        }

        const request = {
            jobNumber: submissionVM.quoteID.value,
            sessionUUID: submissionVM.sessionUUID.value,
            eventType: MLCustomHistoryTypes.InquiryCompleted
        };
        showProgressDialog(platformMessages.saveSubmission);

        try {
            await MLHistoryService.createHistoryEvents([request], authHeader);
            const canSkipSave = steps.some((step) => step.mlStepName === nextStepName && !!step.visited);

            if (!canSkipSave) {
                try{
                    setIsUWIssuesPanelVisible(false);

                    const updateDraftPromise = isGPA ? await GatewayLoadSaveService.updateDraftSubmission(submissionVM.value, authHeader)
                        : await LoadSaveService.updateDraftSubmission(submissionVM.value);
                    const res = updateDraftPromise;

                    submissionVM.value = res;
                    updateWizardData(submissionVM);

                    if (checkForGroupAffiliationUwIssues()) {
                        return false;
                    }
                }catch (error) {
                    MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                }
            } else {
                if (checkForGroupAffiliationUwIssues()) {
                    return false;
                }
            }

        } finally {
            hideProgressDialog();
        }
        if (!nextStepVisited()) {
            return submissionVM;
        }
        goNext();
        return false;
    }, [isGPA, validateData, submissionVM, productCode, MLCustomHistoryTypes.InquiryCompleted, showProgressDialog, nextStepVisited, goNext, authHeader, currentStep.mlStepName, steps, changeNextSteps, updateWizardData, checkForGroupAffiliationUwIssues, hideProgressDialog]);

    const resolvers = {
        resolveComponentMap: {
            mlemployersaffiliationscomponent: MLEmployersAffiliationsComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveCallbackMap: {
            onValidate: onValidate,
            onUpdateSearchVal: onUpdateSearchVal,
            onNext: onNext
        },
        resolveClassNameMap: styles
    };

    const getWizardMessage = () => {
        let baseMsg;
        let boldMsg;
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.driversAndVehicles;
        } else if (MLProductCodeUtil.isHomeOwners(productCode) && !MLProductCodeUtil.isHomeOwnersPartialTypeRental(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.propertyDetails;
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.discounts;
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.policyInfo;
        }
        if (_.isUndefined(baseMsg) || _.isUndefined(boldMsg)) {
            return undefined;
        }
        return (
            <FormattedMessage
                {...baseMsg}
                values={{
                    boldText: (
                        <strong>{translator(boldMsg)}</strong>
                    )
                }}
            />
        );
    };

    const showAdditionalCarrierPopup = () => {
        const componentProps = {
            title: translator(messages.additionalCarrierButtonLabel),
            isGPA,
            viewModel: submissionVM,
            accountNumber: submissionVM?.baseData?.accountNumber?.value,
            overrideProps: {
                jobNumber: submissionVM.quoteID.value,
            },
            isOpen: { isOpenAdditionalCarrierPopup },
            onReject: () => setIsOpenAdditionalCarrierPopup(false),
            onResolve: () => setIsOpenAdditionalCarrierPopup(false),
            saveBindableChoiceReport,
            updateAdditionalCarrier,
            authHeader
        };

        return <MLAdditionalCarrierPopup {...componentProps} />

    };

    const handleAdditionalCarrierPopup = () => {
        setIsOpenAdditionalCarrierPopup(true)
    }

    const overrides = {
        gpaPageHeader: {
            visible: isGPA
        },
        contentContainer: {
            className: isGPA ? 'page-content-gpa' : ''
        },
        affiliationContentHeader: {
            className: isGPA ? 'section-header vertical-spacing-20 padding-bottom-0' : 'page-header vertical-spacing-20 padding-bottom-0 headerOne',
            content: isGPA ? translator(messages.gpaSectionHeader) : translator(messages.affiliationHeader),
            "tabindex": -1
        },
        employersAffiliationsComponent: {
            model: submissionVM,
            updateWizardData: updateWizardData,
            setDisableNextButton: setDisableNextButton,
            isEndorsement: false,
            showErrors,
            isSkipping: isSkipping && skipOnResumeIf(),
            blockOnNext: shouldBlockOnNext,
            isModernProduct
        },
        nextDescription: {
            content: getWizardMessage()
        },
        nextButton: {
            disabled: disableNextButton
        },
        skipDiscountLink: {
            visible: showSkipEmployerDiscount
        },
        returnToQuoteButton: {
            visible: !isQNB && showReturnToQuote,
            disabled: true
        },
        uwIssueContainer: {
            visible: isQNB ? false : isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        additionalCarrierButton: {
            onClick: handleAdditionalCarrierPopup,
            visible: isGPA && showAdditionCarrierBtn && MLUserTypeUtil.isOnlyGCSUser(submissionVM)
        }
    };

    return (
        <div>
            <WizardPage
                skipWhen={skipOnResumeIf}
                showCancel={false}
                showPrevious={false}
                showNext={!nextStepVisited()}
                onNext={onNext}
                showTextNextToButton={!nextStepVisited()}
                nextLabel={translator(platformMessages.mlContinue)}
                textNextToButton={getWizardMessage()}
                metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
                showReturnToQuote={showReturnToQuote && canRequote}
                disableNext={disableNextButton}
                disableReturnToQuote={!canRequote || disableNextButton}
                updateWizardData={updateWizardData}
                validateData={validateData}
                history={history}
                showSkipEmployerDiscount = {showSkipEmployerDiscount}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    model={submissionVM}
                    onModelChange={updateWizardData}
                    componentMap={resolvers.resolveComponentMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    onValidationChange={onValidate}
                />
                <ScrollToError counter={errorTimestamp} />
            </WizardPage>
            {isOpenAdditionalCarrierPopup && showAdditionalCarrierPopup()}
        </div>

    );
};

AffiliationPage.propTypes = wizardProps;
export default withRouter(AffiliationPage);
